export class OrderItemRequest {
    public name = '';
    public document = '';
    public register = '';
    public costCenter: number[] = [];
    public unit: number[] = [];
    public departament: number[] = [];
    public orderby: string = '';
    public ordertype: boolean;
    public situation: string;
    public hasApp: boolean;
}